import styled from "styled-components";

import { breakpoints } from "../../../constants/breakpoints";

export const Wrap = styled.div`
  /* Mobile / default */
  .contentDescription {
    & > p {
      font-size: 20px;
    }
    & > p:nth-child(2) {
      font-size: 16px;
      & > a {
        text-decoration: none;
        color: var(--blue500);
        font-weight: var(--font-sb);
      }
    }
  }

  /* Tablet breakpoint */
  @media only screen and (min-width: ${breakpoints.tablet}px) {
  }

  /* Desktop breakpoint */
  @media only screen and (min-width: ${breakpoints.desktop}px) {
    .contentDescription > p {
      font-size: 24px;
    }
  }
`;
